// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { pascalCase } from '../api/utility';
import Icon from './Icon';

const Wrapper = styled.div`
    font-size: 1.2em;
    font-weight: 800;
    padding: 0.5em 0;
`;
const I = styled(Icon)`
    margin-right: 0.5em;
`;

const Title = ({ children, ...props }) => (
    <Wrapper {...props}>
        {props.icon ? <I icon={props.icon} /> : null}
        {typeof children === 'string' ? pascalCase(children) : children}
    </Wrapper>
);


export default Title;